import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import publicApi from '../services/publicApi';
import { useAuth } from './AuthContext';

const CoinsContext = createContext();

export function useCoins() {
  return useContext(CoinsContext);
}

export function CoinsProvider({ children }) {
  const { currentUser } = useAuth();
  const isLoggedIn = !!currentUser;
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCoins = async () => {
    try {
      // Use appropriate API based on authentication status
      const response = isLoggedIn 
        ? await api.get('/api/coins')
        : await publicApi.get('/api/public/coins');
      const coinsData = response.data;
      
      setCoins(coinsData);
      setError(null);
    } catch (err) {
      console.error('Error fetching coins:', err);
      setError('Failed to load coins');
    } finally {
      setLoading(false);
    }
  };

  const refreshCoins = async () => {
    setLoading(true);
    await fetchCoins();
  };

  useEffect(() => {
    fetchCoins();
  }, [isLoggedIn]);

  const value = {
    coins,
    loading,
    error,
    refreshCoins
  };

  return (
    <CoinsContext.Provider value={value}>
      {children}
    </CoinsContext.Provider>
  );
} 